import { OnlineSales } from 'gw-edge-client';
import type { CustomerStopDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const useGetVIDCustomerStop = (): {
    getVIDCustomerStop: (accountNumber: string) => Promise<CustomerStopDTO>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const getVIDCustomerStop = async (accountNumber: string): Promise<CustomerStopDTO> => {
        return await OnlineSales.getVIDCustomerStop(jobNumber, accountNumber, sessionId);
    };

    return { getVIDCustomerStop };
};
